import type React from 'react';

import * as Styled from './Tag.styled';
import type { TagProps } from './types';
import { TagVariant } from './types';

const Tag: React.FC<TagProps> = ({
  className,
  variant = TagVariant.WHITE,
  size = 'regular',
  LeftIcon,
  RightIcon,
  Icon,
  children,
  textDataTestId = 'tag-text',
  textClassName,
  ...props
}) => {
  const isIconOnly = Icon !== undefined || children === undefined;
  const isStringChildren = typeof children === 'string';

  return (
    <Styled.Wrapper
      $isIconOnly={isIconOnly}
      $size={size}
      $variant={variant}
      className={className}
      {...props}
    >
      {Icon ? (
        <Icon size="sm" />
      ) : isStringChildren ? (
        <>
          {LeftIcon && <LeftIcon size="sm" />}
          <Styled.Text className={textClassName} data-test-id={textDataTestId}>
            {children}
          </Styled.Text>
          {RightIcon && <RightIcon size="sm" />}
        </>
      ) : (
        <>
          {LeftIcon && <LeftIcon size="sm" />}
          {children}
          {RightIcon && <RightIcon size="sm" />}
        </>
      )}
    </Styled.Wrapper>
  );
};

export { Tag };

export { type TagProps, type TagSize, TagVariant } from './types';
